<button tabindex="-1" class="close-button" [mat-dialog-close]="undefined" mat-icon-button>
  <mat-icon class="notranslate">close</mat-icon>
</button>

<h1>Asset details</h1>

<mat-dialog-content>

  <ul class="details-list">
    <!-- Lot size -->
    <li *ngIf="asset.lotSizeArea !== null && asset.lotSizeArea !== undefined" class="details-list-item">
      <label>Lot Size [{{ asset.areaUnits | enumString : AreaUnit }}]</label>{{ asset.lotSizeArea | terraNumber }}
    </li>

    <!-- Stories -->
    <li *ngIf="asset.stories !== null && asset.stories !== undefined" class="details-list-item">
      <label>Number of Floors</label>{{ asset.stories | terraNumber }}
    </li>

    <!-- Residential units -->
    <li *ngIf="asset.residentialUnits !== null && asset.residentialUnits !== undefined" class="details-list-item">
      <label>Number of Residential Units</label>{{ asset.residentialUnits | terraNumber }}
    </li>

    <!-- Retail units -->
    <li *ngIf="asset.retailUnits !== null && asset.retailUnits !== undefined" class="details-list-item">
      <label>Number of Retail Units</label>{{ asset.retailUnits  | terraNumber }}
    </li>

    <!-- Rooms -->
    <li *ngIf="asset.rooms !== null && asset.rooms !== undefined" class="details-list-item">
      <label>Number of Rooms</label>{{ asset.rooms | terraNumber }}
    </li>

    <!--Gross building area -->
    <li *ngIf="asset.grossBuildingArea  !== null && asset.grossBuildingArea !== undefined" class="details-list-item">
      <label>Gross Building
        [{{ asset.areaUnits | enumString : AreaUnit }}]</label>{{ asset.grossBuildingArea | terraNumber }}
    </li>

    <!--Residential Net Sellable Area -->
    <li *ngIf="asset.residentialNetSellableArea  !== null && asset.residentialNetSellableArea !== undefined" class="details-list-item">
      <label>Residential Net Sellable
        [{{ asset.areaUnits | enumString : AreaUnit }}]</label>{{ asset.residentialNetSellableArea | terraNumber }}
    </li>

    <!--Retail Net Sellable Area -->
    <li *ngIf="asset.retailNetSellableArea  !== null && asset.retailNetSellableArea !== undefined" class="details-list-item">
      <label>Retail Net Sellable
        [{{ asset.areaUnits | enumString : AreaUnit }}]</label>{{ asset.retailNetSellableArea | terraNumber }}
    </li>

      <!--Number of sites -->
      <li *ngIf="asset.numberOfSites !== null && asset.numberOfSites !== undefined" class="details-list-item">
        <label>Number of Sites</label>
        {{ asset.numberOfSites | terraNumber }}
      </li>
  </ul>

</mat-dialog-content>
